/**
 * colorworkCharts — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const colorworkChartsPack: ToilePack = {
    slug: 'colorwork-charts',
    category: 'colorwork',
    name: 'Colorwork charts',
    tagline: tagline('charts', 'motifs', 'treatments'),
    chips: chips('motifs', 'treatments'),
    ratio: SQUARE,
    readings: [
        {key: 'fairisle', label: 'Fair-isle band', subject: 'peerie motifs, OXO panels and small diamonds'},
        {key: 'snowflake', label: 'Nordic snowflake', subject: 'an eight-point snowflake with dot fillers'},
        {key: 'argyle', label: 'Argyle', subject: 'large diamonds crossed by thin diagonal lines'},
    ],
    styles: [
        {key: 'chart', label: 'Charted grid', style: 'stranded-colorwork chart, one square per stitch', palette: 'flat squares on a white grid', framing: 'exact grid, hard pixel edges'},
        {key: 'swatch', label: 'Knit swatch', style: 'knitted stockinette swatch, stitches in clear V shapes', palette: 'bright traditional shetland colors', framing: 'flat swatch, straight on'},
        {key: 'muted', label: 'Muted palette', style: 'knitted piece in heathered wool', palette: 'oatmeal, moss, rust and slate', framing: 'flat, straight on, low contrast'},
    ],
    directions: ['a reindeer motif instead', 'in cream and rust', 'a narrower band'],
}
